const getToken = () => {
  let token;
  Object.keys(localStorage).filter((key) => /accessToken$/.test(key)).forEach((key) => {
    token = localStorage.getItem(key);
  });
  return token;
};
export default getToken;
